import { defineMessage } from 'services/localization';

export const messages = {
    participantRulesPreviewAmountPattern: defineMessage('amount_is_amount'),
    participantRulesPreviewNumberFieldPattern: defineMessage('fieldname_is_amount'),
    participantRulesPreviewAmountPatternNet: defineMessage('net_amount_is_amount'),
    participantRulesPreviewAmountPatternGross: defineMessage('total_amount_is_amount'),
    participantRulesPreviewAmountPatternAbove: defineMessage('over_or_equal_to_greatereq_currency'),
    participantRulesPreviewAmountPatternBelow: defineMessage('under_less_currency'),
    participantRulesPreviewAmountPatternWithin: defineMessage('over_or_equal_to_greatereq_and_under_less_currency'),
    participantRulesPreviewFieldValuePattern: defineMessage('value'),
    participantRulesPreviewFieldGroupValuePattern: defineMessage('group_nameversionnumber'),
    participantRulesPreviewNotFieldPattern: defineMessage('fieldname_does_not_match_values'),
    participantRulesPreviewFieldPattern: defineMessage('fieldname_matches_values'),
    participantBooleanRuleEnabled: defineMessage('fieldname_enabled'),
    participantBooleanRuleDisabled: defineMessage('fieldname_disabled'),
    participantRulesPreviewAndText: defineMessage('left_and_right'),
    participantRulesPreviewOrText: defineMessage('left_or_right'),
    editorRulesPreviewNotFieldPattern: defineMessage('fieldname_to_any_value_except_values'),
    editorRulesPreviewFieldPattern: defineMessage('fieldname_to_values'),
    editorRulesPreviewAlwaysApprove: defineMessage('can_set_any_values'),
    editorRulesPreviewAndText: defineMessage('left_and_right'),
    editorRulesPreviewOrText: defineMessage('left_or_right'),
    editorRulesPreviewCanSet: defineMessage('can_set_rules'),
    participantRulesPreviewApprovesWhen: defineMessage('should_approve_if_rules'),
    participantRulesPreviewAlwaysApprove: defineMessage('should_approve_everything'),
    participantRulesPreviewReviewWhen: defineMessage('should_review_if_rules'),
    participantRulesPreviewAlwaysReview: defineMessage('should_review_everything'),
};
